import { render, staticRenderFns } from "./DieselDashboard.vue?vue&type=template&id=ec4ae032&scoped=true"
import script from "./DieselDashboard.vue?vue&type=script&lang=js"
export * from "./DieselDashboard.vue?vue&type=script&lang=js"
import style0 from "./DieselDashboard.vue?vue&type=style&index=0&id=ec4ae032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4ae032",
  null
  
)

export default component.exports